export default function Loading() {
  return (
    <div className="loading">
      <div className="spinner-border text-light" role="status">
        <span className="sr-only"></span>
      </div>
    </div>
  );
}
